/**
 * Buyer PDP estimated-weight UI gate.
 * Shows notices only when the feature flag is on and
 * `requires_weight_adjustment === true` from authenticated product detail.
 */
export function shouldShowEstimatedWeightUi(
  isFeatureEnabled: boolean,
  requiresWeightAdjustment: boolean | null | undefined
): boolean {
  if (!isFeatureEnabled) {
    return false;
  }

  return requiresWeightAdjustment === true;
}
